export default __webpack_public_path__ + "static/ai-create-dark-b480e015b759d28ceb07a88077a0372ccda4df938c30501d2f2bece4680a31db.png";